import { DialogContent, Grid, Skeleton, Typography } from "@mui/material";
import React from "react";
import convertCurrency, { convertIntMoney } from "src/helper/convertCurrency";
import useCustomAddressDetail from "src/hooks/user/customer/useCustomAddressDetail";
import useCustomerBrandDetail from "src/hooks/user/customer/useCustomerBrandDetail";
import useCustomerDetail from "src/hooks/user/customer/useCustomerDetail";

export default function CustomerViewDialog({ item }) {
  const { data: customer, isLoading } = useCustomerDetail(item?._id);
  const { data: address } = useCustomAddressDetail(item?._id);
  const { data: brand } = useCustomerBrandDetail(item?._id);

  return (
    <DialogContent>
      <Grid container>
        <Grid
          xs={12}
          item
          mb="6px"
        >
          <Typography
            fontSize="18px"
            fontWeight="bold"
          >
            Thông tin khách hàng
          </Typography>
        </Grid>
        <Grid
          xs={12}
          item
        >
          {isLoading ? (
            <Skeleton
              width="100%"
              height="56px"
            />
          ) : (
            <>
              <Typography mb="6px">
                <strong>Tên khách hàng:</strong> {customer?.data?.fullName ?? "-"}
              </Typography>
              <Typography mb="6px">
                <strong>Email:</strong> {customer?.data?.email ?? "-"}
              </Typography>
              <Typography mb="6px">
                <strong>Số điện thoại:</strong> {customer?.data?.phone ?? "-"}
              </Typography>
              <Typography mb="6px">
                <strong>NV phụ trách:</strong> {customer?.data?.sales?.fullName ?? "-"}
              </Typography>
            </>
          )}
        </Grid>
        {[...(address?.data ?? [])]
          .sort((a, b) => Number(b?.isDefault === true) - Number(a?.isDefault === true))
          .map((v) => {
            return (
              <Grid
                key={v?._id}
                xs={12}
                item
                sx={{
                  background: "var(--light-grey)",
                  borderRadius: "6px",
                  mb: "12px",
                  p: "6px 8px",
                }}
              >
                <Typography
                  display="flex"
                  gap={1}
                >
                  <strong>Địa chỉ cụ thể:</strong>{" "}
                  {v?.isDefault && (
                    <Typography
                      component="span"
                      bgcolor="var(--success)"
                      color="var(--success-txt)"
                      fontWeight={700}
                      px={1}
                      py={0.5}
                      borderRadius="50px"
                      variant="caption"
                    >
                      Mặc định
                    </Typography>
                  )}
                </Typography>
                <Typography>{v?.phone ?? "-"}</Typography>
                <Typography>
                  {v?.detailAddress + ", "} {v?.ward?.path ?? v?.ward?.name}
                  {v?.country?.name ? ", " + v?.country?.name : ""}
                </Typography>
              </Grid>
            );
          })}

        <Grid
          xs={12}
          item
          mt="24px"
          mb="12px"
        >
          <Typography
            fontSize="18px"
            fontWeight="bold"
          >
            Chiết khấu (%)
          </Typography>
        </Grid>
        <Grid
          xs={12}
          item
        >
          {isLoading ? (
            <Skeleton
              width="100%"
              height="56px"
            />
          ) : (
            <>
              <Typography mb="6px">
                <strong>Giới hạn tổng công nợ:</strong> {convertIntMoney(customer?.data?.debtLimit) ?? 0} đồng
              </Typography>
              <Typography
                fontWeight="bold"
                sx={{ fontStyle: "italic" }}
                mb="12px"
              >
                ({convertCurrency(customer?.data?.debtLimit) ?? 0} đồng)
              </Typography>
            </>
          )}
        </Grid>
        {brand?.data?.map((v) => {
          return (
            <Grid
              key={v?._id}
              xs={12}
              item
              sx={{
                background: "var(--light-grey)",
                borderRadius: "6px",
                mb: "12px",
                p: "6px 8px",
              }}
            >
              <Typography mb="8px">
                <strong>Tên thương hiệu:</strong> {v?.brand?.name ?? "-"}
              </Typography>
              <Typography>
                <strong>Giới hạn tổng công nợ:</strong> {convertIntMoney(v?.debtLimit) + "VND"}
              </Typography>
              <Typography
                mb="8px"
                fontWeight="bold"
                sx={{ fontStyle: "italic" }}
              >
                ({convertCurrency(v?.debtLimit)} đồng)
              </Typography>
              <Typography>
                <strong>Chiết khấu (%):</strong> {v?.discount ?? 0}%
              </Typography>
            </Grid>
          );
        })}
      </Grid>
    </DialogContent>
  );
}
